import React, { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

interface NavigationLinkProps {
    link: string
    className?: string
    target?: string
    id?: string
}

const NavigationLink: FC<NavigationLinkProps> = ({ children, ...rest }) => {
    const [isExternal, setIsExternal] = useState(false)

    const checkNavigation = (link: string) => {
        if (link?.includes('http') || link?.includes('https')) {
            setIsExternal(true)
        } else {
            setIsExternal(false)
        }
    }

    useEffect(() => {
        checkNavigation(rest.link)
    }, [rest?.link])

    return (
        <>
            {isExternal ? (
                <a
                    className={rest.className}
                    href={rest.link}
                    target={rest.target}
                    id={rest.id ? rest.id : ''}
                >
                    {children}
                </a>
            ) : (
                <Link
                    to={rest.link}
                    className={rest.className}
                    id={rest.id ? rest.id : ''}
                >
                    {children}
                </Link>
            )}
        </>
    )
}

export default NavigationLink
